import React, { Component } from "react";
import cx from "classnames";
import nanoid from "nanoid";
import * as icons from "../../icons";
import "./_styles.scss";
import { WindowExplorer } from "packard-belle";
import Window from "../tools/Window";
import buildMenu from "../../helpers/menuBuilder";

const noop = () => {};

const canAccessIframe = id => {
  const iframe = document && document.querySelector(`.${id}`);
  const canAccess =
    iframe &&
    iframe.contentDocument &&
    iframe.contentDocument.body &&
    iframe.contentDocument.body.scrollHeight;
  if (canAccess) {
    return {
      height: iframe.contentDocument.body.scrollHeight,
      width: iframe.contentDocument.body.scrollWidth
    };
  }
};

class InternetExplorer extends Component {
  id = "b".concat(nanoid()).replace("-", "");
  contentRef = React.createRef();
  state = { dimensions: { width: 800, height: 400 } };

  componentDidMount() {
    setTimeout(this.getIframeDimension, 3000);
    document.addEventListener("click", this.handleToolbarDelegated, true);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleToolbarDelegated, true);
  }
  handleToolbarDelegated = (e) => {
    const btn = e.target && e.target.closest && e.target.closest("button");
    if (!btn) return;
    if (!btn.closest("." + this.id)) return;
    const text = btn.querySelector(".ButtonIconLarge__text");
    if (!text) return;
    if (text.textContent.trim().toLowerCase() !== "print") return;
    e.preventDefault();
    e.stopPropagation();
    this.handlePrint();
  };
  getIframeDimension = () => {
    const iframeDimensions = canAccessIframe(this.id);
    if (iframeDimensions && iframeDimensions !== this.state.dimensions) {
      this.setState({ dimensions: iframeDimensions });
    }
  };
  handleContentClick = (e) => {
    // Let mailto and tel links work naturally - don't intercept them
  };
  handlePrint = () => {
    const { props } = this;

    if (props.data && props.data.src && !props.data.__html) {
      const iframe = document.querySelector(`iframe.${this.id}`);
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (e) {
        window.open(props.data.src, "_blank", "noopener,noreferrer");
      }
      return;
    }

    const html = props.data && props.data.__html;
    if (!html) return;

    const title = (props.data.title || props.title || "Print").replace(/[<>]/g, "");
    const doc =
      `<!doctype html><html><head><meta charset="utf-8"><title>${title}</title></head>` +
      `<body>${html}</body></html>`;

    const printer = document.createElement("iframe");
    printer.style.position = "fixed";
    printer.style.right = "0";
    printer.style.bottom = "0";
    printer.style.width = "0";
    printer.style.height = "0";
    printer.style.border = "0";
    printer.setAttribute("aria-hidden", "true");

    let fired = false;
    const cleanup = () => {
      try { document.body.removeChild(printer); } catch (_) {}
    };
    const fire = () => {
      if (fired) return;
      fired = true;
      try {
        printer.contentWindow.focus();
        printer.contentWindow.print();
      } catch (e) {
        const w = window.open("", "_blank", "noopener,noreferrer");
        if (w) {
          w.document.open();
          w.document.write(doc);
          w.document.close();
          w.focus();
          setTimeout(() => { try { w.print(); } catch (_) {} }, 300);
        }
      } finally {
        setTimeout(cleanup, 2500);
      }
    };

    document.body.appendChild(printer);
    // Defer everything past the initial about:blank load tick
    setTimeout(() => {
      printer.addEventListener("load", () => {
        // Give external images a moment to fetch before triggering the dialog
        setTimeout(fire, 400);
      });
      printer.srcdoc = doc;
      // Hard fallback in case load never fires (offline images, blocked resources, etc.)
      setTimeout(fire, 3000);
    }, 0);
  };
  render() {
    const { props } = this;
    return (
      <Window
        {...props}
        Component={WindowExplorer}
        className={cx("InternetExplorer", this.id, props.className)}
        title={`${
          props.data.title || props.title !== "Internet Explorer (WIP)"
            ? `${props.data.title || props.title} - `
            : ""
        }Internet Explorer (WIP)`}
        menuOptions={buildMenu(props)}
        minHeight={300}
        minWidth={300}
        explorerOptions={[
          {
            icon: icons.back,
            title: "Back",
            onClick: noop
          },
          {
            icon: icons.forward,
            title: "Forward",
            onClick: noop
          },
          {
            icon: icons.ieStop,
            title: "Stop",
            onClick: noop
          },
          {
            icon: icons.ieRefresh,
            title: "Refresh",
            onClick: noop
          },
          {
            icon: icons.ieHome,
            title: "Home",
            onClick: noop
          },
          {
            icon: icons.ieSearch,
            title: "Search",
            onClick: noop
          },
          {
            icon: icons.ieFavorites,
            title: "Favorites",
            onClick: noop
          },
          {
            icon: icons.ieHistory,
            title: "History",
            onClick: noop
          },
          {
            icon: icons.ieMail,
            title: "Mail",
            onClick: noop
          },
          {
            icon: icons.iePrint,
            title: "Print",
            onClick: this.handlePrint
          }
        ]}
      >
        {props.data.__html && (
          <div
            ref={this.contentRef}
            style={{ margin: "2px 1px 0px 2px", minHeight: "calc(100% - 4px)" }}
            dangerouslySetInnerHTML={props.data}
            onClick={this.handleContentClick}
          />
        )}
        {props.children}
        {props.data &&
          !props.data.html &&
          props.data.src &&
          (this.state.dimensions ? (
            <div style={{ ...this.state.dimensions }}>
              <iframe
                className={this.id}
                frameBorder="0"
                src={props.data.src}
                title={props.data.src}
                importance="low"
                height="480"
                width="640"
                {...this.state.dimensions}
              />
            </div>
          ) : (
            <iframe
              className={cx(this.id, "crossOrigin")}
              scrolling="no"
              frameBorder="0"
              src={"http://localhost:3000/" || props.data.src}
              title={props.data.src}
              importance="low"
              height="480"
              width="640"
            />
          ))}
      </Window>
    );
  }
}

export default InternetExplorer;

// initialHeight, initialWidth, title, icon, footer, id,
// onClose, onMaximize, isActive, explorerOptions, chidlren, data, customSelect, Component
